<h3>{{ "MAPA.data_type_selection" | translate }}</h3>

<mat-form-field class="tipos-datos-chip-list">
  <mat-chip-list
    #chipList
    aria-label="TiposDatos selection"
    class="tipos-dato-chip-list"
  >
    <mat-chip
      color="primary"
      *ngFor="let tipoDato of tiposDatos; let i = index"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(tipoDato)"
    >
      {{ tipoDato }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      placeholder="..."
      #tiposDatosInput
      [formControl]="tiposDatosCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"
    />
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option
      *ngFor="let tipoDato of filteredTiposDatos | async"
      [value]="tipoDato"
    >
      <!-- {{tipoDato}} -->
      <!-- TODO: Revisar -->
      <!-- {{
        ("DATA_TYPES_AND_CODES.".concat(tipoDato) | translate) ||
          ("AGRUPACIONES.".concat(tiposDatos) | translate)
      }} -->
      {{ "DATA_TYPES_AND_CODES.".concat(tipoDato) | translate }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<div class="mt-3">
  <button mat-raised-button [mat-dialog-close]>
    {{ "DASHBOARD.FORM.CANCEL" | translate }}
  </button>
  <!-- [disabled]="tiposDatos.length <= 0" -->
  <button
    (click)="choseData()"
    mat-raised-button
    color="primary"
    class="right"
    [mat-dialog-close]="tiposDatosSelected"
    cdkFocusInitial
  >
    {{ "DASHBOARD.FORM.ACCEPT" | translate }}
  </button>
</div>
